module.exports = __webpack_public_path__ + "static/img/home_banner4.07bf30e4.png";